export class FieldValue {
    constructor(marker) {
        this.marker = marker;
    }
    static serverTimestamp() {
        return new FieldValue({ __type__: 'serverTimestamp' });
    }
    static arrayUnion(...elements) {
        return new FieldValue({ __type__: 'arrayUnion', elements });
    }
    static arrayRemove(...elements) {
        return new FieldValue({ __type__: 'arrayRemove', elements });
    }
    static delete() {
        return new FieldValue({ __type__: 'delete' });
    }
    static increment(operand) {
        return new FieldValue({ __type__: 'increment', operand });
    }
    toJSON() {
        return Object.assign({}, this.marker);
    }
}
//# sourceMappingURL=field-value.js.map